import React, { useRef, useState } from 'react';
import { Arrow } from '../components/Icons';

function Contact() {
  const form = useRef();
  const [status, setStatus] = useState('idle');
  const [errorMessage, setErrorMessage] = useState('');
  const formId = (process.env.REACT_APP_FORMSPREE_FORM_ID || '').trim();
  const isConfigured = /^[a-zA-Z0-9]+$/.test(formId);
  async function send(e) {
    e.preventDefault();
    if (status === 'sending' || !isConfigured) return;
    setErrorMessage('');
    setStatus('sending');
    try {
      const response = await fetch(`https://formspree.io/f/${formId}`, {
        method: 'POST',
        body: new FormData(form.current),
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) {
        const data = await response.json().catch(() => null);
        const details = data?.errors?.map(error => error.message).filter(Boolean).join(' ');
        setErrorMessage(details || 'Your enquiry couldn’t be sent. Please try again later.');
        setStatus('error');
        return;
      }
      setStatus('sent');
      form.current.reset();
    } catch {
      setErrorMessage('Your enquiry couldn’t be sent. Please check your connection and try again.');
      setStatus('error');
    }
  }
  return <section className="section contact-page"><div className="contact-overview">
    <span className="eyebrow"><i /> CONTACT</span><h1>Contact us</h1><p>Do you have any questions?</p>
    <p className="contact-intro-detail">Tell us about your mining or infrastructure project, including its location, timing, and the support you need.</p>

    <div className="contact-image"><img src="/background-4.jpg" alt="Large blue dragline excavator working at an open-pit mine"/><span className="contact-image-mark" aria-hidden="true">+</span></div>
  </div><form ref={form} onSubmit={send} aria-busy={status === 'sending'}><h2>Do you need some consulting?</h2><p className="contact-form-note">Fields marked with * are required.</p><div className="form-row"><label htmlFor="name">Full Name <span>*</span><input id="name" name="name" autoComplete="name" required placeholder="Your full name" /></label><label htmlFor="email">Email <span>*</span><input id="email" type="email" name="email" autoComplete="email" required placeholder="you@company.com" /></label></div><label htmlFor="phone">Phone number <span>(optional)</span><input id="phone" type="tel" name="phone" autoComplete="tel" placeholder="Include country code" /></label><label htmlFor="message">Message <span>*</span><textarea id="message" name="message" required rows="5" placeholder="Enter message..." /></label><button type="submit" className="button dark-button" disabled={!isConfigured || status === 'sending'}>{status === 'sending' ? 'Sending…' : 'Send'}<Arrow diagonal /></button><div role="status" aria-live="polite">{!isConfigured && <p className="form-status error">Our contact form is temporarily unavailable. Please try again later.</p>}{status === 'sent' && <p className="form-status">Thank you for contacting us. We will get back to you shortly.</p>}{status === 'error' && <p className="form-status error">{errorMessage}</p>}</div></form></section>;
}

export default Contact;
